
import licensePdfRuTazadeal from '../assets/licenses/Лицензионное соглашение TazaDeal КР_ред.16.01.pdf';
import licensePdfRuAthena from '../assets/licenses/Лицензионное соглашение Афина_рус.pdf';
import cookieAgreementPdfRuTazadeal from '../assets/licenses/Политика использования файлов cookie TDT_16.01.pdf';
import cookieAgreementPdfRuAthena from '../assets/licenses/Политика использования файлов cookie_LST 16.01.pdf';
import privacyAgreementPdfRuTazadeal from '../assets/licenses/Политика конфиденциальности TDT 16.01.pdf';
import privacyAgreementPdfRuAthena from '../assets/licenses/Политика конфиденциальности Афина_рус.pdf';
import termsOfUsePdfRuTazadeal from '../assets/licenses/Общие условия использования TazaDeal (Terms of use) KP_ред.16.01.pdf';
import termsOfUsePdfRuAthena from '../assets/licenses/Общие_условия_использования_Athena РФ_ред. 16.01.pdf';
import publicOfferRu from '../assets/licenses/Публичная_оферта_Афина_21.09.pdf';

export type IBuildLanguage = {
  [key in BuildNames]: {
    [key in Languages]?: string;
  }
};

export enum BuildNames {
  Athena = 'athena',
  Tazadeal = 'tazadeal',
};

export enum Languages {
  Ru = 'ru',
  En = 'en',
  Es = 'es',
  Kg = 'kg',
};

export const licensesOfApp: IBuildLanguage = {
  [BuildNames.Tazadeal]: {
    [Languages.Ru]: licensePdfRuTazadeal,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
  [BuildNames.Athena]: {
    [Languages.Ru]: licensePdfRuAthena,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
};


export const cookieAgreements: IBuildLanguage = {
  [BuildNames.Tazadeal]: {
    [Languages.Ru]: cookieAgreementPdfRuTazadeal,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
  [BuildNames.Athena]: {
    [Languages.Ru]: cookieAgreementPdfRuAthena,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
};

export const privacyAgreement: IBuildLanguage = {
  [BuildNames.Tazadeal]: {
    [Languages.Ru]: privacyAgreementPdfRuTazadeal,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
  [BuildNames.Athena]: {
    [Languages.Ru]: privacyAgreementPdfRuAthena,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
};


export const temsOfUse: IBuildLanguage = {
  [BuildNames.Tazadeal]: {
    [Languages.Ru]: termsOfUsePdfRuTazadeal,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
  [BuildNames.Athena]: {
    [Languages.Ru]: termsOfUsePdfRuAthena,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
};

export const publicOffer: IBuildLanguage = {
  [BuildNames.Tazadeal]: {
    [Languages.Ru]: publicOfferRu,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
  [BuildNames.Athena]: {
    [Languages.Ru]: publicOfferRu,
    [Languages.En]: '',
    [Languages.Es]: '',
    [Languages.Kg]: '',
  },
};

